module.exports = __webpack_public_path__ + "static/media/rank-mini-3-icon.3e957378.png";